import { render, staticRenderFns } from "./MPBookDamaged.vue?vue&type=template&id=86aee2ee&scoped=true"
import script from "./MPBookDamaged.vue?vue&type=script&lang=js"
export * from "./MPBookDamaged.vue?vue&type=script&lang=js"
import style0 from "./MPBookDamaged.vue?vue&type=style&index=0&id=86aee2ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86aee2ee",
  null
  
)

export default component.exports